/**
 * Created by liubaorui on 22/11/14.
 * 私有问题尽量不要修改或添加进此文件， 在不清楚逻辑的情况下慎重修改内部方法。
 * TODO: 所有涉及直接DOM操作的方法 应该被优化
 *
 * @param  {关闭操作列显隐持久化功能 从业务文件option属性里读取}   closeToolbar   true关闭
 * @param  {关闭自动处理根据查询列数排列按钮 从业务文件option属性里读取}  closeSearchAuto          true关闭
 * @param  {关闭重构的适配方案 从业务文件option属性里读取} cancelHijack      true关闭
 * @param  {新增时单位只有一个时默认选中 从业务文件option属性里读取  默认打开} cancelDefault true关闭
 * @param  {查询时单位只有一个时默认选中 从业务文件option属性里读取  默认打开} cancelSearchDefault  true关闭
 *
 */
import _ from 'lodash';
import { resizeGridSize } from '@/basic-common/util/common';
import { desensitizationDispose } from "@/basic-common/util/desensitization.js";
import { getAllWeekBeforeNowFn } from "@/util/date";
import { numSeparator, mutationObserver, hijackFn, setSeparator, formDefaultValueMothods } from '@/basic-common/util/common';
import website from '@/config/website';
import { removePercent } from '@/util/util'

export default function (config) {
  return {
    data () {
      let that = this
      return {
        dialogFormStyle: '',//解决bug 记录dialog的Style
        initstate: false,//拦截首次
        form: {},
        query: {},
        loading: true,// 表格loading
        defaults: {}, //avue默认值
        page: {
          pageSize: 20, // 每页显示20条
          currentPage: 1, // 第一页
          total: 0 // 总条数
        },
        selectionList: [], //选中列表
        data: [], //列表数据
        responseData: null, //列表相应数据集
        getTableHeightEvent: function () { that.$nextTick(() => { that.$refs.crud && that.$refs.crud.getTableHeight() }) },
      }
    },
    created () {
      // 默认值
      this.headerDefaultval();
    },
    mounted () {
      // 默认加载或处理
      this.CrudMixinsInit();
    },
    // keep-alive开启后的处理 清除上一次的处理
    activated () {
      process.nextTick(() => {
        this.$refs.crud && this.$refs.crud.doLayout();
      })
      if (this.option) {
        !this.option.cancelHijack && window.addEventListener("resize", this.getTableHeightEvent);
        !this.option.cancelHijack && this.$refs.crud && this.$refs.crud.getTableHeight();
      }
    },
    deactivated () {
      this.option && !this.option.cancelHijack && window.removeEventListener("resize", this.getTableHeightEvent);
    },
    methods: {
      setSeparator,
      CrudMixinsInit () {
        if (this.option) {
          // -- 是否需要列显隐
          !this.option.closeToolbar && this.getDataPersistence();
          !this.option.closeToolbar && this.dataPersistence();

          // -- 是否需要自动排列查询条件及按钮 参数为统一排列的列数 目前支持 3 || 4
          !this.option.closeSearchAuto && this.queryAutoArrange(this.option.searchSpanNumber);

          // -- 是否需要重新计算表格以完成适配
          !this.option.cancelHijack && hijackFn(this.$refs.crud, 'getTableHeight', this.hijackerTableHeight);
          !this.option.cancelHijack && window.addEventListener("resize", this.getTableHeightEvent);
          !this.option.cancelHijack && this.getTableHeightEvent();

          // 新增默认值 目前包含（mineCode）
          !this.option.cancelDefault && this.fullScreenAvueFormAdd();

          // -- 重新编译Placeholder值 不需要删除即可 不提供参数关闭
          this.setPlaceholde();

          // -- avue生成详情界面问题处理 含超出提示 自定义插槽可编辑。 不建议注释
          this.disposeDetail();

          // -- 重写avue缩放逻辑 如果项目内无缩放功能可以删除
          this.fullScreen();

          // -- 处理搜索区域折叠按钮根据不同状态显示图标
          this.inintSearchShowBtnIcon();
        }
      },

      /* =================================================== Avue回调 ==========================================================  */
      handleToVoid () {
        if (this.selectionList.length === 0) {
          this.$message.warning('请选择至少一条数据');
          return;
        }
        this.$confirm_danger('作废', () => {
          config.toVoid(this.ids).then((res) => {
            this.onLoad(this.page);
            this.$message({
              type: 'success',
              message: res.data.msg
            });
            this.$refs.crud.toggleSelection();
          });
        })
      },
      rowSave (row, done, loading) {
        config.add(row).then((res) => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: res.data.msg
          });
          done();
        }, () => {
          loading();
        });
      },
      rowUpdate (row, index, done, loading) {
        config.update(row).then((res) => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: res.data.msg
          });
          done();
        }, () => {
          loading();
        });
      },
      rowDel (row) {
        this.$confirm_danger('删除', () => {
          config.remove(row.id).then((res) => {
            this.onLoad(this.page);
            this.$message({
              type: 'success',
              message: res.data.msg
            });
          });
        })
      },
      handleDelete () {
        if (this.selectionList.length === 0) {
          this.$message.warning('请选择至少一条数据');
          return;
        }
        this.$confirm_danger('删除', () => {
          config.remove(this.ids).then((res) => {
            this.onLoad(this.page);
            this.$message({
              type: 'success',
              message: res.data.msg
            });
            this.$refs.crud.toggleSelection();
          });
        })
      },
      beforeOpen (done, type) {
        if (['edit', 'view'].includes(type)) {
          config.getDetail(this.form.id).then(res => {
            this.form = res.data.data;
          });
        }
        done();
      },
      //row-class-name回调， 添加了选中底色
      rowClass ({ rowIndex }) {
        const checkboxData = this.selectionList.map((item) => item.$index)
        if (checkboxData.includes(rowIndex)) {
          return 'slecleRowColor ';
        }
      },
      searchReset () {
        const containsEnglishLetter = (str) => {
          return /[a-zA-Z]/.test(str);
        }
        this.query = {};
        const notReset = ['searchBeginTime', 'searchEndTime', 'searchDate']
        this.option.column.forEach(item => {
          if (item.searchDisabled === true) {
            this.$set(this.query, item.prop, item.searchValue)
          } else if (notReset.includes(item.prop) && item.searchValue) {
            if (containsEnglishLetter(item.searchValue)) {
              this.$set(this.query, item.prop, formDefaultValueMothods(item, 'searchValue'))
            } else {
              this.$set(this.query, item.prop, item.searchValue)
              this.$set(item, 'searchValue', item.searchValue)
            }
          }
        })
        this.onLoad(this.page, this.query);
      },
      searchChange (params, done) {
        this.query = params;
        this.page.currentPage = 1;
        this.onLoad(this.page, params);
        done();
      },
      selectionChange (list) {
        this.selectionList = list;
      },
      selectionClear () {
        this.selectionList = [];
        this.$refs.crud && this.$refs.crud.toggleSelection();
      },
      currentChange (currentPage) {
        this.page.currentPage = currentPage;
      },
      sizeChange (pageSize) {
        this.page.pageSize = pageSize;
      },
      refreshChange () {
        this.onLoad(this.page, this.query);
      },
      setLoading () {
        if (this.$el) {
          const crudDom = this.$el.querySelector('.avue-crud__search') || ''
          const menuBtn = crudDom && crudDom.querySelector('.avue-form__menu')
          if (menuBtn) {
            const menuBtnItem = Array.from(menuBtn.querySelectorAll('.el-button'))
            menuBtnItem.forEach((item) => {
              item.classList.add('button-disable')
              const i_tag = item.querySelector('i')
              if (i_tag) {
                const icon = i_tag.classList[0]
                i_tag.classList = []
                i_tag.classList.add('el-icon-loading')
                const option = this.option || {}
                setTimeout(() => {
                  i_tag.classList = [icon];
                  item.classList.remove('button-disable')
                }, option.option || 1000)
              }
            })
          }
        }
      },
      onLoad (page, params = {}) {
        if (this.initstate) {
          this.initstate = false
          return
        }
        // 设置查询触发间隔
        this.setLoading()
        // 组织为最后一级默认选中
        this.setMineCodeDefault('list') && this.$set(_.find(this.option.column, { 'prop': 'deptId' }), 'searchValue', this.setMineCodeDefault('list'));

        this.loading = true;
        let queryData = this.removeNullAttribute(Object.assign(params, this.query))
        // 去除参数%
        queryData = removePercent(this.deepClone(queryData))
        config.getList(page.currentPage, page.pageSize, queryData).then(res => {
          this.responseData = res.data.data;
          this.page.total = this.responseData.total;
          this.data = numSeparator(this.responseData.records, this.option, 'list'); //千位符处理
          this.data = desensitizationDispose(this.responseData.records, 'list'); //脱敏
          this.loading = false;
          this.selectionClear();
        }).catch(() => {
          this.loading = false;
          this.data = []
        }).finally(() => {
          this.$nextTick(() => {
            if (this.option && !this.option.cancelHijack && this.$refs.crud) {
              this.$refs.crud.getTableHeight && this.$refs.crud.getTableHeight()
              this.$refs.crud.doLayout && this.$refs.crud.doLayout()
            }
          })
        })
      },
      /* ==================================================== END  ==========================================================  */


      /* =======================================  涉及直接操作或间接操作 DOM 的通用处理或添加 =================================== */
      /*
       *  非万不得已不要直接操作 DOM.
       *  mvvm 数据驱动的虚拟 DOM 优于--》 $refs 链操作 优于---》 直接 DOM 操作
      */
      // 操作列记忆功能数据流获取
      getDataPersistence () {
        this.$axios({
          url: website.getPersistenceApi,
          method: 'get',
          params: { url: this.$route.path },
        }).then(({ data: { data: res_data } }) => {
          if (res_data && res_data.params) {
            let data_column = JSON.parse(res_data.params);
            const Persistence = ['hide', 'fixed', 'filters', 'sortable', 'filter', 'screen'];
            this.option.column.forEach(item => {
              data_column.map((data_item) => {
                if (item.prop == data_item.prop) {
                  Persistence.forEach((fieldItem) => {
                    this.$set(item, fieldItem, data_item[fieldItem]);
                  })
                }
              })
            })
          }
        })
      },

      // 操作列记忆功能迁移   !*涉及直接操作DOM
      dataPersistence () {
        let el_drawer = document.getElementsByClassName('el-drawer__close-btn');
        let newIcon = null;
        if (el_drawer.length) {
          Array.from(el_drawer).forEach((item) => {
            if (item.ariaLabel == 'close 列显隐') {
              let icon = document.createElement("i");
              icon.className = 'el-dialog__close el-icon el-icon-circle-check behavior'
              if (!item.getElementsByClassName('behavior').length) {
                item.appendChild(icon);
                newIcon = Array.from(item.getElementsByClassName('behavior'));
                newIcon.forEach((item) => {
                  item.addEventListener('click', this.handlerBehavior, false)
                })
              }
            }
          });
        }
      },

      // 记忆操作保存
      handlerBehavior ($event) {
        let dataList = [];
        this.option.column.map(item => {
          dataList.push({
            prop: item.prop,
            hide: item.hide || false,
            fixed: item.fixed || false,
            filters: item.filters || false,
            sortable: item.sortable || false,
            filter: item.filter || false,
            screen: item.screen || false,
          });
        });

        const data = { params: JSON.stringify(dataList), url: this.$route.path, };
        this.$axios({ url: website.setPersistenceApi, method: 'post', data, }).then(() => {
          this.$message({ type: "success", message: "操作成功!" });
        }).catch(() => {
          this.$message.error('操作失败请重试');
        })
        $event.stopPropagation();
      },

      //！=======  原 ： 1. 修改按钮对齐样式 setQueryStyle  !*涉及直接操作DOM  2.查询按钮区域居右 queryBtnTheRight  !*涉及直接操作DOM。 已被优化  ======！

      // 处理搜索区域折叠按钮根据不同状态显示图标  !*涉及直接操作DOM
      inintSearchShowBtnIcon () {
        let elBtnNodes = this.$refs.crud && this.$refs.crud.$el && this.$refs.crud.$el.querySelectorAll('.avue-crud__menu > .avue-crud__right > .el-button');
        let lastBtnNodes = null;
        if (elBtnNodes && elBtnNodes.length) {
          lastBtnNodes = elBtnNodes[elBtnNodes.length - 1];
          lastBtnNodes.querySelector('i') ? lastBtnNodes.querySelector('i').className = "el-icon-top" : false;
        }
        // 监听显示隐藏按钮
        if (lastBtnNodes && lastBtnNodes.addEventListener) {
          lastBtnNodes.addEventListener("click", function (eObj) {
            if (eObj.target) {
              let claName = '';
              if (eObj.target.lastElementChild) {
                claName = eObj.target.lastElementChild.className == 'el-icon-top' ? 'el-icon-bottom' : 'el-icon-top';
                eObj.target.lastElementChild.className = claName;
              } else {
                claName = eObj.target.className == 'el-icon-top' ? 'el-icon-bottom' : 'el-icon-top';
                eObj.target.className = claName;
              }
            }
          });
        }
      },

      /* ==================================================== END  ===============================================================  */


      /* =================================================== 通用问题解决 ==========================================================  */
      // 解决因fixed 拖动后导致错位问题
      headerDragend () {
        this.$nextTick(() => {
          this.$refs.crud.doLayout();
        })
      },

      // 自动根据查询框数量排序按钮
      queryAutoArrange (spanAutoNumber) {
        const spanNumber = spanAutoNumber || 3;
        if (this.option && this.option.column) {
          if (!this.option.searchMenuPosition) this.option.searchMenuPosition = 'right';
          const searchNumber = this.option.column.filter((item) => item.search) || [];
          resizeGridSize(searchNumber, spanNumber, this.option);
        }
      },

      // getTableHeight 劫持者
      hijackerTableHeight () {
        let that = this
        return function () {
          that.getTableHeight()
        }
      },

      // FullScreen 劫持者
      hijackerFullScreen () {
        this.$nextTick(() => {
          const crud = this.$refs.crud || null
          const dialogForm = crud && crud.$refs.dialogForm
          const dragDom = dialogForm.$el.querySelector('.el-dialog');
          if (dialogForm && this.dialogFormStyle) {
            dragDom.style = this.dialogFormStyle
          }

          //====== 迁移avue源码内容 =====
          if (dialogForm.isDrawer) {
            if (dialogForm.validatenull(dialogForm.size)) {
              dialogForm.size = '100%'
            } else {
              dialogForm.size = ''
            }
          }
          if (dialogForm.fullscreen) {
            dragDom.style = this.dialogFormStyle
            dialogForm.fullscreen = false;
          } else {
            dialogForm.fullscreen = true;
            this.dialogFormStyle = _.cloneDeep(dragDom.style)
            dragDom.style = dragDom.styleName;
          }
        })
      },

      // AvueForm 新增劫持
      fullScreenAvueFormAdd () {
        // 单表同文件默认单位处理
        if (this.$refs.crud) {
          const callBackAdd = this.$refs.crud.rowAdd
          this.$refs.crud.rowAdd = () => {
            callBackAdd()
            process.nextTick(() => {
              this.setMineCodeDefault('add') && this.$set(this.form, 'deptId', this.setMineCodeDefault('add'))
            })
          }
        }
        // 通用非同文件默认单位处理
        if (this.beforeOpen) {
          const { userInfo } = this.$store.state.user
          if (userInfo.hasChildDept !== false) return
          const callBeforeOpen = (org) => {
            const that = this
            return function (done = () => { }, type) {
              const isMinCode = that.mainTableConfigList && _.find(that.mainTableConfigList, { 'columnAlias': 'deptId' });
              org(done, type)
              if (type == 'add' && isMinCode) {
                that.$set(isMinCode, 'initialValue', userInfo.dept_id)
              }
            }
          }
          hijackFn(this, 'beforeOpen', callBeforeOpen)
        }
      },

      /*
        因层级过深把覆盖展开写，不采用封装的劫持
        此方法完全依赖于ref属性。 如果你的<avue-crud> 标签ref值不等于 “crud” 此方法将不奏效。
     */
      fullScreen () {
        const crud = this.$refs.crud || null
        const dialogForm = crud && crud.$refs.dialogForm
        if (dialogForm)
          dialogForm.handleFullScreen = this.hijackerFullScreen
      },

      /*
        劫持avue回调并重构avue表格假适配逻辑
        此方法完全依赖于ref属性。 如果你的<avue-crud> 标签ref值不等于 “crud” 此方法将不奏效。
      */
      getTableHeight () {
        this.$nextTick(() => {
          const ThCrud = this.$refs.crud.$refs;
          const tableRef = ThCrud.table;
          if (!tableRef) return
          const getPaginationHeight = (node) => {
            const el = node && typeof node.querySelector === 'function'
              ? node
              : this.$refs.crud.$el.querySelector('.avue-crud__pagination')
            if (!el) return 0
            const pagination = el.querySelector('.el-pagination')
            const hasPagination = pagination && pagination.offsetParent !== null
            el.classList && el.classList.toggle('avue-crud__pagination--empty', !hasPagination)
            if (!hasPagination) return 0
            const body = el.querySelector('.el-card__body')
            const bodyStyle = body ? window.getComputedStyle(body) : null
            const outerStyle = window.getComputedStyle(el)
            const paddingTop = bodyStyle ? parseFloat(bodyStyle.paddingTop || 0) : 0
            const paddingBottom = bodyStyle ? parseFloat(bodyStyle.paddingBottom || 0) : 0
            const marginTop = parseFloat(outerStyle.marginTop || 0)
            const marginBottom = parseFloat(outerStyle.marginBottom || 0)
            return pagination.offsetHeight + paddingTop + paddingBottom + marginTop + marginBottom
          }
          // 内容区域内 查询盒子
          const domHeight = document.documentElement.clientHeight
          const tableTop = tableRef.$el.getBoundingClientRect().top || 0
          const pageStyle = getPaginationHeight(ThCrud.tablePage && ThCrud.tablePage.$el)
          // 内容之外区域 头部
          //尾部插槽
          const crud_footer = this.$refs.crud_footer ? this.$refs.crud_footer.$el.offsetHeight : 0
          if (!this.option.height || this.option.height == 'auto') {
            this.$refs.crud.tableHeight = Math.max(180, domHeight - tableTop - pageStyle - crud_footer - 45)
          } else {
            this.$refs.crud.tableHeight = this.option.height;
          }
          this.$nextTick(() => {
            this.$refs.crud && this.$refs.crud.doLayout && this.$refs.crud.doLayout()
          })
        })
      },

      /* 关于avue详情的一些处理，
         此方法完全依赖于ref属性。 如果你的<avue-crud> 标签ref值不等于 “crud” 此方法将不奏效。
      */
      disposeDetail () {
        if (!this.$refs.crud) return
        this.$nextTick(() => {
          const moDom = this.$refs.crud && this.$refs.crud.$refs.dialogForm.$el;
          const callBack = function () {
            let AvueDetail = moDom && moDom.querySelector('.avue--detail');
            if (AvueDetail) {
              let InmputDetail = AvueDetail.getElementsByTagName('input');
              // 给予avue表单渲染时间
              process.nextTick(() => {
                Array.from(InmputDetail).forEach((item) => {
                  item.parentElement.onmouseover = function () {
                    item.title = item.value;
                  }
                  item.parentElement.addEventListener('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                  })
                  item.disabled = true
                })
              })
            }
          };
          mutationObserver(callBack, moDom)
        })
      },

      // 统一处理生成代码的placeholder
      setPlaceholde () {
        this.option.column.forEach((item) => {
          if (!item.placeholder) {
            if (!item.type || item.type == 'input' || item.type == 'textarea') {
              item.placeholder = '请输入';
            } else {
              item.placeholder = '请选择';
            }
            // 单独处理拼音码 可能没有考虑到所有情况 如果有误在item里添加自己的placeholder即可
            if (item.remote && item.dicUrl) {
              item.placeholder = '拼音码检索';
            }
          }
        })
      },

      // 同步赋默认值
      headerDefaultval () {
        //  查询时间相关  支持 时间集 时间组
        if (this.option && this.option.searchDateProp !== false) {
          this.setSearchDate()
        }
        //处理选中时间问题
        const searchDate = _.find(this.option.column, { 'prop': 'searchDate' })
        if(searchDate&&searchDate!=-1){
           searchDate && this.$set(searchDate,'defaultTime',['00:00:00', '23:59:59'])
        }
        // 其余默认赋值 顺延.......
      },

      /* 关于异步赋默认值， 默认查询单位mineCode 建议一致 非一致修改关联字段
         此方法完全依赖于ref属性。 如果你的<avue-crud> 标签ref值不等于 “crud” 此方法将不奏效。
      */
      setMineCodeDefault (type) {
        const { userInfo } = this.$store.state.user
        const isMinCode = _.find(this.option.column, { 'prop': 'deptId' })
        if (userInfo.hasChildDept === false) {
          if (type == 'list' && isMinCode && isMinCode.search && !this.option.cancelSearchDefault) {
            this.$set(this.query, 'deptId', userInfo.dept_id)
            return userInfo.dept_id
          } else if (type != 'list' && isMinCode && !this.option.cancelDefault) {
            return userInfo.dept_id
          }
        }
        return false
      },

      // 默认查新时间处理
      setSearchDate () {
        //简写原生对象
        const orgObject = Object.prototype.toString
        //查询日期关键字的key
        const searchDateProp = this.option.searchDateProp || 'searchDate'
        //一 设置 时间集
        if (!this.option.searchDateProp || orgObject.call(searchDateProp) == '[object String]') {
          let searchDateObjct = _.find(this.option.column, { 'prop': searchDateProp })  //查询日期配置对象
          if (searchDateObjct && searchDateObjct.search) {
            this.$set(this.query, searchDateProp, getAllWeekBeforeNowFn())
            this.$set(searchDateObjct, 'searchValue', getAllWeekBeforeNowFn())
          }
        } else if (orgObject.call(searchDateProp) == '[object Object]') {

          // 时间组必须包含约束的起止字段
          if (Object.keys(searchDateProp).includes('startTime') && Object.keys(searchDateProp).includes('endTime')) {
            //  设置时间组 查询 和显示默认值
            try {
              const searchDateStart = _.find(this.option.column, { 'prop': searchDateProp.startTime })  //开始查询日期配置对象
              const searchDateEndTime = _.find(this.option.column, { 'prop': searchDateProp.endTime })  //结束查询日期配置对象
              const getTime = getAllWeekBeforeNowFn(searchDateProp.type).split(',')  //处理的时间
              // 开始日期
              searchDateStart.search && this.$set(this.query, searchDateProp.startTime, getTime[0])
              searchDateStart.search && this.$set(searchDateStart, 'searchValue', getTime[0])
              // 结束日期
              searchDateEndTime.search && this.$set(this.query, searchDateProp.endTime, getTime[1])
              searchDateEndTime.search && this.$set(searchDateEndTime, 'searchValue', getTime[1])

            } catch {
              throw new Error('当前时间查询为日期组，searchDateProp未设置正确对应关系或未找到设置的字段')
            }
            //仅有开始字段 默认当作时间集来处理
          } else if (Object.keys(searchDateProp).includes('startTime')) {
            let searchDateObjct = _.find(this.option.column, { 'prop': searchDateProp.startTime })  //查询日期配置对象
            if (searchDateObjct && searchDateObjct.search) {
              this.$set(this.query, searchDateProp.startTime, getAllWeekBeforeNowFn(searchDateProp.type))
              this.$set(searchDateObjct, 'searchValue', getAllWeekBeforeNowFn(searchDateProp.type))
            }
          }
        }
      },

      //默认值含有函数方法相关处理
      queryMenuExceMethod () {
        // console.log("in 获取所有method")
        //  获取本组件下的所有method
        // const methods = this.$options.methods
        _.forEach(this.option.column, item => {
          // 判断是否需要执行函数
          //目前判断查询条件默认值
          if (!!item.searchValue && item.search) {
            // 使用this.$options.methods 会有this指向问题
            // console.log("判断是否函数",Object.prototype.toString.call(methods[item.searchValue])==="[object Function]")

            this.query[item.prop] = formDefaultValueMothods(item, 'searchValue')
          }
          //其余默认值

          //例: formDefaultValueMothods(item,'Value')
        })
      },

      removeNullAttribute (obj) {
        for (let key in obj) {
          if (obj[key] === '') {
            delete obj[key]
          }
        }
        return obj
      },

      /* ==================================================== END  ==================================================================  */
    }
  }
}
